import { Image } from '@/atoms/Image'
import { AngelLogo } from '@/atoms/Logos/AngelLogo'
import { ResponsiveBackgroundImage } from '@/atoms/ResponsiveBackgroundImage'
import { HeadingSM, HeadingXL, ParagraphSM } from '@/atoms/Text'
import { useLocale } from '@/utils/LocaleUtil'
import { useTranslate } from '@/utils/translate/translate-client'

export const OurMissionView = () => {
  const { t } = useTranslate('about')
  const { locale } = useLocale()

  return (
    <main className="relative flex h-fit min-h-screen w-screen items-start justify-center overflow-x-hidden py-24 text-white">
      <ResponsiveBackgroundImage
        src="/v1706832194/angel-studios/landing/show-wall-fade-240130-btm-right_1.webp"
        preBackgroundStyles="linear-gradient(70deg, rgba(0, 0, 0, 0.38) 0%, #151515 100%), "
        className="pointer-events-none min-h-screen touch-none select-none"
      />

      <section className="z-0">
        <HeadingSM weight="semibold" className="photon-paragraph-xl md:photon-heading-sm pb-2 text-center lg:text-left">
          {t('ourMission', `Our Mission`)}
        </HeadingSM>
        <HeadingXL
          className="photon-heading-xs md:photon-heading-lg lg:photon-heading-xl text-center lg:text-left"
          weight="bold"
        >
          {t('angelNorthStar', `Angel's North Star Letter`)}
        </HeadingXL>
        <div className="mx-2 mt-14 flex max-w-[900px] flex-col gap-8 rounded-3xl bg-white px-8 py-[44px] text-black md:mx-4 md:px-14">
          <AngelLogo color="black" className="mx-auto" height={56} />
          <ParagraphSM className="text-right">
            {new Date('2021-03-06T00:00:00.000').toLocaleDateString(locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </ParagraphSM>
          <ParagraphSM className="flex flex-col gap-y-4 md:gap-y-8">
            <span>{t('northStar1', 'Dear film fan,')}</span>
            <span>
              {t(
                'northStar2',
                'We’re building a home for stories that amplify light (or, as we call it, our North Star).',
              )}
            </span>
            <span>
              {t(
                'northStar3v1',
                `How do we define light? True, honest, noble, just, authentic, lovely,
              admirable, and excellent.`,
              )}
            </span>
            <span>
              {t(
                'northStar4',
                `Just as a compass, the stars and magnetic North guided sailors through dark waters centuries ago, our
              North Star for filmmaking helps us navigate dark times and focus on light in our day.`,
              )}
            </span>
            <span>
              {t(
                'northStar5',
                `Darkness can seem pervasive. Last year introduced fires all over Australia, pandemic, economic turmoil,
              locusts infestations, rising food prices, protests and riots, earthquakes, and financial warfare (look up
              Hedge Funds and GameStop). Sometimes it feels as if the tumultuous events are becoming more frequent.`,
              )}
            </span>
            <span>
              {t(
                'northStar6',
                `There’s a reason the film business was one of the few industries that grew during the Great Depression.
              Hope is a fundamental human need and in yesteryear, the filmmakers mastered storytelling to meet that
              need.`,
              )}
            </span>
            <span>
              {t(
                'northStar7v1',
                `Unfortunately, most shows offered these days add to the cynicism, division, and darkness so pervasive in
              society. Fortunately, darkness and light, hope and despair, cannot exist in the same place at the same
              time. And we believe if we build a home for creators and communities to connect, specifically those who
              align with our North Star, Angel will become known for fulfilling our universal human need for
              hope and light. Our time feels short. Choosing, funding, creating, and spreading stories that matter has
              never felt more urgent.`,
              )}
            </span>
            <span>
              {t(
                'northStar8',
                `Whether as a customer, investor or team member thank you for joining
              us.`,
              )}
            </span>
          </ParagraphSM>
          <div>
            <Image
              className="pointer-events-none touch-none select-none"
              priority
              width={180}
              height={91}
              alt="North Star Signature"
              src={'/v1702932854/angel-app/angel-studios/neal-sig.png'}
            />
            <ParagraphSM weight="bold">Neal Harmon</ParagraphSM>
            <ParagraphSM>{t('coFounderCEO', 'Co-Founder and CEO')}</ParagraphSM>
            <ParagraphSM>Angel</ParagraphSM>
          </div>
        </div>
      </section>
    </main>
  )
}
